var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-row', {
    staticClass: "ma-0",
    "class": _vm.$vuetify.breakpoint.xs ? 'px-4 pt-6' : 'px-8 pt-8'
  }, [_c('v-col', {
    staticClass: "pt-0 pb-0 px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "min-width": "150px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm.$store.state.auth.empresa.logo ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.$store.state.auth.empresa.logo,
      "alt": "Logo"
    }
  }) : _vm._e()]), !_vm.$store.state.auth.empresa.logo ? _c('v-skeleton-loader', {
    attrs: {
      "type": "image",
      "max-height": "42",
      "max-width": "200"
    }
  }) : _vm._e()], 1), _c('v-spacer'), _vm.$store.state.auth.cliente.id ? _c('div', {
    staticClass: "pl-4 text-right text-truncate",
    staticStyle: {
      "line-height": "16px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$store.state.auth.cliente.nome) + " "), _c('br'), _c('span', {
    staticClass: "text--secondary text-body-2"
  }, [_vm._v(" " + _vm._s(_vm._f("documentoCliente")(_vm.$store.state.auth.cliente.documento)) + " ")])]) : _vm._e()], 1)]), _c('v-col', {
    staticClass: "pt-3 px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "ml-divider"
  })])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };